import { render, staticRenderFns } from "./integer-input.vue?vue&type=template&id=0f1b4cfc&scoped=true"
import script from "./integer-input.vue?vue&type=script&lang=js"
export * from "./integer-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1b4cfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f1b4cfc')) {
      api.createRecord('0f1b4cfc', component.options)
    } else {
      api.reload('0f1b4cfc', component.options)
    }
    module.hot.accept("./integer-input.vue?vue&type=template&id=0f1b4cfc&scoped=true", function () {
      api.rerender('0f1b4cfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/number-input/integer-input.vue"
export default component.exports